// src/constants/config/getToken.js
import { msalInstance } from "./authConfig";

export const getToken = async () => {
  try {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      const response = await msalInstance.acquireTokenSilent({
        scopes: ["user.read", "User.ReadBasic.All"],
        account: accounts[0],
      });
      return response.accessToken;
    } else {
      throw new Error("No accounts found");
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error acquiring token", error);
    throw error;
  }
};
